import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Archive from "@/pages/Archive";
import WeekDetail from "@/pages/WeekDetail";
import Admin from "@/pages/Admin";
import AdminPages from "@/pages/AdminPages";
import Pages from "@/pages/Pages";
import Membership from "@/pages/Membership";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="App relative">
      <div className="paper-grain fixed inset-0 z-0" />
      <BrowserRouter>
        <AuthProvider>
          <div className="relative z-10">
            <Navbar />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/archive"
                element={
                  <ProtectedRoute>
                    <Archive />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/archive/:id"
                element={
                  <ProtectedRoute>
                    <WeekDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/pages"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pages"
                element={
                  <ProtectedRoute>
                    <Pages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/membership"
                element={
                  <ProtectedRoute>
                    <Membership />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payment/success"
                element={
                  <ProtectedRoute>
                    <PaymentSuccess />
                  </ProtectedRoute>
                }
              />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </div>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            border: "1px solid #D5CFC4",
            borderRadius: "2px",
            color: "#1C1B18",
            fontFamily: "Lora, serif",
          },
        }}
      />
    </div>
  );
}

export default App;
